import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Header.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/state";
const Header = () => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const refWrap = useRef(null);
  const refNav = useRef(null);
  const refOverlay = useRef(null);
  const { updatePopupOpen, isMobile, popupOpen } = state;
  const [isOpen, setOpen] = useState(false);
  useEffect(() => {
    const wrap = refWrap.current;
    const scrollHandler = () => {
      if (window.scrollY >= window.innerHeight * 0.5) {
        wrap.classList.add(styles.shown);
      } else {
        wrap.classList.remove(styles.shown);
      }
    }
    window.addEventListener('scroll', scrollHandler);
  }, []);
  useEffect(() => {
    const nav = refNav.current;
    const overlay = refOverlay.current;
    const body = document.body;
    if (!isMobile || popupOpen) return;
    if (isOpen) {
      nav.classList.add(styles.active);
      overlay.classList.add(styles.active);
      body.style.overflow = 'hidden';
    } else {
      nav.classList.remove(styles.active);
      overlay.classList.remove(styles.active);
      body.style.overflow = '';
    }
    return () => {
      nav.classList.remove(styles.active);
      overlay.classList.remove(styles.active);
      body.style.overflow = '';
    }
  }, [isMobile, isOpen, popupOpen]);
  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
        <div className={styles.inner}>
          <a href='https://www.infografika.agency/' className={styles.logo}>
            <picture>
              <source media="(max-width: 767px)" srcSet={`${path}/img/logo-mobile.svg`} />
              <img src={`${path}/img/logo.svg`} alt="" />
            </picture>
          </a>
          <div className={styles.overlay} ref={refOverlay}></div>
          <div className={styles.menu} onClick={() => setOpen(true)}>Меню</div>
          <nav className={styles.nav} ref={refNav}>
            <div className={styles.nav__close} onClick={() => setOpen(false)}>
              <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="25.5" cy="25.5" r="24.5" stroke="#BDBFCD" strokeWidth="2" />
                <path d="M35.5 16L25.25 26.25M15 36.5L25.25 26.25M25.25 26.25L15 16L35.5 36.5" stroke="#BDBFCD" strokeWidth="2" />
              </svg>
            </div>
            <div className={styles.nav__body}>
              <div className={styles.nav__inner}>
                <a href="https://www.infografika.agency/" className={styles.link}><span>Главная</span></a>
                <a href="https://www.infografika.agency/team" className={styles.link}><span>О нас</span></a>
                <a href="https://www.infografika.agency/cases-ru" className={styles.link}><span>Кейсы</span></a>
                <a href="https://www.infografika.agency/presales" className={styles.link}><span>Пресейлы</span></a>
                <button className={styles.link} onClick={() => { updatePopupOpen(true); setOpen(false) }}>
                  {isMobile ?
                    <span>Сотрудничать</span>
                    :
                    <span>Заказать проект</span>
                  }
                </button>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </>
  );

}

export default Header;
